import { DataTableEmptyCell } from "@bcc/components/data-table";
import type { PurchaseOrder } from "@shared/types";
import { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

export const OrderWeightCell = (props: CellContext<PurchaseOrder, unknown>) => {
  const { t } = useTranslation();
  const weightInGrams = props.row.original.orderWeightInGrams;

  if (!weightInGrams) return <DataTableEmptyCell />;

  return <span className="text-sm">{t("weight.weightWithSuffix", { grams: weightInGrams })}</span>;
};
